export default __webpack_public_path__ + "static/media/assignedDrivers.3e7b4920.svg";